import type { Link } from "../../../../aysa_api/models/link.types";

export enum LinkType {
  UNSPECIFIED = 0,
  CONTACT = 1,
  SECOND_HAND_SERVICE = 2,
}

export interface MetaLink {
  link: Link;
  type: LinkType;
}
